import { GET_TIPO_ZONA_IVA, ADD_TIPO_ZONA_IVA, MODIFY_TIPO_ZONA_IVA, DELETE_TIPO_ZONA_IVA, UPDATE_TIPO_ZONA_IVA } from '../constants/action_types';

const initialState = {
    tiposzona: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPO_ZONA_IVA:
            return {
                ...state,
                isLoading: true
            };

        case GET_TIPO_ZONA_IVA + "_SUCCESS":
            return {
                tiposzona: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_ZONA_IVA:

            const newArr = [...state.tiposzona, action.payload]
            return {
                tiposzona: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_ZONA_IVA:

            return {
                tiposzona: state.tiposzona.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_ZONA_IVA:

            return {
                tiposzona: state.tiposzona.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPO_ZONA_IVA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}